import { render, staticRenderFns } from "./formContact.vue?vue&type=template&id=26c83d72&"
import script from "./formContact.vue?vue&type=script&lang=js&"
export * from "./formContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports